
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import MylobyLoadMore from "@/components/generic/load-more.vue";
import Timeout = NodeJS.Timeout;

const DEBOUNCE_TIME_MILLI: number = 500;

@Component({
  components: { MylobyLoadMore },
})
export default class CompanyUsersMultiAutocomplete extends Vue {

  @Prop({default: null})
  public companyId: number;

  @Prop({default: null})
  public initItem: any;

  private users: any[] = [];
  private totalUsers: number = 0;
  private usersPagination = {
    page: 0,
    itemsPerPage: 10,
  };
  private userSearch: string = null;
  private loadingUsers: boolean = false;
  private selectedUsers: any[] = [];
  private timerId: Timeout = null;

  @Getter private envCompanyId: number|null;

  @Watch("userSearch", {immediate: false})
  public handleUserSearch() {
    return this.userSearch !== null
      ? this.getFirstUsersDelayed()
      : this.getFirstUsers();
  }

  get formattedUsersValues(): any[] {
    // Ensure selected users are always visible
    const alreadySelected = this.selectedUsers
      .filter((selectedUser) => !this.users.some((u) =>  u.id === selectedUser.id));
    return [...alreadySelected, ...this.users];
  }

  private mounted(): void {
    if (this.initItem) {
      this.selectedUsers = [this.initItem];
      this.$emit("update", this.selectedUsers);
    }
    this.getFirstUsers();
  }

  private getFirstUsersDelayed(): void {
    this.loadingUsers = true;
    // cancel pending call
    clearTimeout(this.timerId);
    // delay new call
    this.timerId = setTimeout(() => {
      this.getFirstUsers();
    }, DEBOUNCE_TIME_MILLI);
  }

  private async getFirstUsers(): Promise<void> {
    this.usersPagination.page = 1;
    this.users = [];
    await this.getContactAndSubordinateList();
  }

  private async getNextUsers(): Promise<void> {
    this.usersPagination.page++;
    await this.getContactAndSubordinateList();
  }

  private async getContactAndSubordinateList(): Promise<void> {
    this.loadingUsers = true;
    await this.$store.dispatch("companies/getContactsAndSubordinates", {
      id: this.envCompanyId,
      query: {
        search: this.userSearch,
        page: this.usersPagination.page,
        itemsPerPage: this.usersPagination.itemsPerPage,
        excludeIds: this.selectedUsers.map(({ id }) => id),
      },
    }).then((res) => {
      this.users = [...this.users, ...res.rows];
      this.totalUsers = res.count || 0;
    }).catch((error) => {
      this.$store.commit("alerts/displayHttpError", { error });
    }).finally(() => {
      this.loadingUsers = false;
    });
  }

  private async updatedSelectedUsers(): Promise<void> {
    this.$emit("update", this.selectedUsers);
    await this.getFirstUsers();
  }

  private removeItemFromSelectedUser(userToRemove): void {
    this.selectedUsers = this.selectedUsers.filter((user) => user.id !== userToRemove.id);
    this.updatedSelectedUsers();
  }
}
